import { LocationSessionOption } from '@abg/typings/biz/location.interface';

import { RECENT_LOCATIONS_LOCAL_STORAGE_KEY } from './hooks/location-search-options/location-search-options.utils';
import { LocationSuggestionOption } from './location-search.types';

export const getFormattedValueByLocationSiteType = (
  value: LocationSuggestionOption,
): LocationSuggestionOption => {
  if (typeof globalThis === 'undefined' || !globalThis.localStorage) {
    return value;
  }

  const isLocationRecent = value?.suggestionTypeCode === 'RECENT';

  if (!isLocationRecent) {
    return value;
  }

  const sessionRecentOptions = localStorage.getItem(
    RECENT_LOCATIONS_LOCAL_STORAGE_KEY,
  );

  if (!sessionRecentOptions) {
    return value;
  }

  const parsedSessionOptions = JSON.parse(
    sessionRecentOptions,
  ) as LocationSessionOption[];
  const recentValue = parsedSessionOptions.find(
    ({ value: { identifier } }) => identifier === value.identifier,
  );

  const formattedValue = {
    ...value,
    suggestionTypeCode: recentValue
      ? recentValue?.initialLocationSiteType
      : value?.suggestionTypeCode,
  };
  const returnedValue = formattedValue || value;

  return returnedValue;
};

export const isSuggestion = (value: LocationSuggestionOption | string | null) =>
  typeof value !== 'string';
